import { render, staticRenderFns } from "./DocumentationProcess.vue?vue&type=template&id=63552b0f"
import script from "./DocumentationProcess.vue?vue&type=script&lang=js"
export * from "./DocumentationProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports